enum ChicaType {
  OF = 'OF',
  Fansly = '',
}

type Chica = {
  type: ChicaType
  name: string
}

export const chicas: Chica[] = [
  { type: ChicaType.Fansly, name: 'a_whole_eternity' },
  { type: ChicaType.Fansly, name: 'AlicePreuoston' },
  { type: ChicaType.Fansly, name: 'LittlePoetry' },
  { type: ChicaType.Fansly, name: 'Riskyproject' },
  { type: ChicaType.Fansly, name: 'TaiteHambelton' },
  { type: ChicaType.Fansly, name: 'One_1ove' },
  { type: ChicaType.Fansly, name: 'Magic_smile' },
  { type: ChicaType.Fansly, name: 'eternity_is_endless' },
  { type: ChicaType.Fansly, name: 'Noreenstabrooks' },
  { type: ChicaType.Fansly, name: 'JasminesTea' },
  { type: ChicaType.Fansly, name: 'FalineCrosthwaite' },
  { type: ChicaType.Fansly, name: 'Esmabraddy' },
  { type: ChicaType.Fansly, name: 'Czamabech' },
  { type: ChicaType.Fansly, name: 'BlissDiley' },
  { type: ChicaType.Fansly, name: 'Lipswithsmileonthem' },
  { type: ChicaType.Fansly, name: 'refined_style' },
  { type: ChicaType.Fansly, name: '_G1ltter_' },
  { type: ChicaType.Fansly, name: 'Junction_of_Love' },
  { type: ChicaType.Fansly, name: 'MaydaEdgin' },
  { type: ChicaType.Fansly, name: 'LynnAlltop' },
  { type: ChicaType.Fansly, name: 'Sue_Kotara' },
  { type: ChicaType.Fansly, name: 'ShiningDawn' },
  { type: ChicaType.Fansly, name: 'Dream_melody' },
  { type: ChicaType.Fansly, name: 'Huba_Booba' },
  { type: ChicaType.Fansly, name: 'One_1ovet' },
  { type: ChicaType.Fansly, name: 'LizbethBiers' },
  { type: ChicaType.Fansly, name: '_marvelous_time_' },
  { type: ChicaType.Fansly, name: 'Oke_Dokes' },
  { type: ChicaType.Fansly, name: 'adeles_vibes' },
  { type: ChicaType.Fansly, name: 'Oke_Doke' },
  { type: ChicaType.Fansly, name: 'moiraalsbrook' },
  { type: ChicaType.Fansly, name: '_wicked_game' },
  { type: ChicaType.Fansly, name: 'gotta_shine' },
  { type: ChicaType.OF, name: 'polly_bee1' },
  { type: ChicaType.OF, name: 'czambech' },
  { type: ChicaType.OF, name: 'lipswithsmileonthem' },
  { type: ChicaType.OF, name: 'lizbethbiers' },
  { type: ChicaType.OF, name: 'norenestabrook' },
  { type: ChicaType.OF, name: 'esmabraddy' },
  { type: ChicaType.OF, name: 'eternity_is_endless' },
  { type: ChicaType.OF, name: 'G1itte' },
  { type: ChicaType.OF, name: 'Silverhaskel' },
  { type: ChicaType.OF, name: 'Sue_Kotara' },
]
